<p-dialog
  [(visible)]="dialogVisible"
  [header]="title"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="script-dialog"
  (onHide)="closeDialog()"
>
  <form [formGroup]="form" (ngSubmit)="save()">

    <!-- Source selector -->
    <div class="p-field source-toggle">
      <label>Script Source</label>
      <div class="p-buttonset">
        <button
          type="button"
          pButton
          label="Inline Code"
          [class.p-button-primary]="!useUrl"
          [class.p-button-outlined]="useUrl"
          (click)="useUrl = false"
        ></button>
        <button
          type="button"
          pButton
          label="Script URL"
          [class.p-button-primary]="useUrl"
          [class.p-button-outlined]="!useUrl"
          (click)="useUrl = true"
        ></button>
      </div>
      <small class="p-text-secondary mt-2">
        <a href="https://moveright.app/resources/scripts" target="_blank" rel="noopener">
          Learn more about writing scripts <i class="pi pi-external-link"></i>
        </a>
      </small>
    </div>

    <!-- Inline code editor -->
    <div class="p-field" *ngIf="!useUrl">
      <label for="scriptCode">JavaScript / TypeScript / TSX</label>
      <textarea
        id="scriptCode"
        formControlName="code"
        pInputTextarea
        [autoResize]="false"
        rows="12"
        class="code-editor"
        [placeholder]="codePlaceholder"
        spellcheck="false"
      ></textarea>
    </div>

    <!-- Script URL with autocomplete -->
    <div class="p-field url-field" *ngIf="useUrl">
      <label for="scriptUrl">Script URL</label>
      <p-autoComplete
        formControlName="scriptUrl"
        [suggestions]="filteredSampleScripts"
        (completeMethod)="filterSampleScripts($event)"
        (onSelect)="onScriptSelected($event)"
        (onBlur)="onUrlBlur()"
        field="label"
        [dropdown]="true"
        placeholder="Search sample scripts or paste a URL…"
        styleClass="url-autocomplete w-full"
        [forceSelection]="false"
        appendTo="body"
      >
        <ng-template let-s pTemplate="item">
          <div class="sample-script-item">
            <div class="sample-label">{{ s.label }}</div>
            <div class="sample-desc">{{ s.description }}</div>
          </div>
        </ng-template>
      </p-autoComplete>
      <small class="p-text-secondary">
        Choose a sample script or paste a URL from
        <strong>functions.moveright.app</strong>.
        TypeScript &amp; TSX are transpiled automatically.
        Name and description are auto-filled from the script's <code>&#64;name</code> / <code>&#64;description</code> comments.
      </small>
    </div>

    <!-- Name -->
    <div class="p-field">
      <label for="scriptName">Name <span class="required">*</span></label>
      <input
        id="scriptName"
        type="text"
        pInputText
        formControlName="name"
        placeholder="e.g. Web Lead Followup"
        class="w-full name-input"
      />
    </div>

    <!-- Description -->
    <div class="p-field">
      <label for="scriptDesc">Description</label>
      <input
        id="scriptDesc"
        type="text"
        pInputText
        formControlName="description"
        placeholder="Short description of what this script does"
        class="w-full desc-input"
      />
    </div>

    <!-- Enabled toggle -->
    <div class="p-field p-field-inline">
      <p-inputSwitch formControlName="enabled" inputId="scriptEnabled"></p-inputSwitch>
      <label for="scriptEnabled" class="ml-2">Enabled</label>
    </div>

  </form>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <div class="left-actions">
        <button
          *ngIf="!isCreate"
          type="button"
          pButton
          label="Delete"
          icon="pi pi-trash"
          class="p-button-danger p-button-outlined"
          [disabled]="loading"
          (click)="confirmDelete()"
        ></button>
      </div>
      <div class="right-actions">
        <button
          type="button"
          pButton
          label="Cancel"
          class="p-button-text"
          [disabled]="loading"
          (click)="closeDialog()"
        ></button>
        <button
          type="button"
          pButton
          [label]="isCreate ? 'Create' : 'Save'"
          icon="pi pi-check"
          [loading]="loading"
          [disabled]="form.invalid || loading"
          (click)="save()"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>